import SaveRounded from '@mui/icons-material/SaveRounded';
import { Button } from '@src/common/components/button/Button';
import { css } from '@src/common/styles/Styles';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick?: () => void;
  disabled?: boolean;
};

export const CreateButton = ({ onClick, disabled }: Props) => {
  const { t } = useTranslation();
  return (
    <Button
      className={createButton}
      disabled={disabled}
      type="submit"
      variant="contained"
      startIcon={<SaveRounded />}
      onClick={onClick}
    >
      {t('create')}
    </Button>
  );
};

const createButton = css({
  borderRadius: '100px',
});
